import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, PropType } from 'vue';
import { createPopper, Instance as PopperInstance, Modifier } from '@popperjs/core';
import { VButton } from 'ah-common-lib/src/common/components';
import { isDescendant } from 'ah-common-lib/src/helpers/dom';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export interface DropdownMenuItem {
  name: string;
  label: string;
  action: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenu',
  props: {
  toggleButtonClass: {
    type: String,
    default: 'btn-primary',
  },
  toggleButtonText: {
    type: String,
    default: 'Menu',
  },
  menuItems: {
    type: Array as PropType<DropdownMenuItem[]>,
    required: true,
  },
},
  setup(__props) {



const isMenuShown = ref(false);

const dropdownMenuEl = ref<HTMLElement>();

const dropdownTarget = ref<HTMLSpanElement>();

let popper: PopperInstance | undefined;

function onWindowClick(event: MouseEvent) {
  if (
    isMenuShown.value &&
    dropdownTarget.value &&
    dropdownMenuEl.value &&
    event.target &&
    !isDescendant([dropdownTarget.value, dropdownMenuEl.value], event.target as Element)
  ) {
    toggleShow(false);
  }
}

const minWidth: Modifier<'minWidth', {}> = {
  name: 'minWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    state.styles.popper.minWidth = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    if (state.elements.reference instanceof HTMLElement) {
      state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
    }
  },
};

const topSpaceOffset = {
  name: 'offset',
  options: {
    offset: [0, 3],
  },
};

onMounted(() => {
  if (dropdownMenuEl.value && dropdownTarget.value) {
    popper = createPopper(dropdownTarget.value, dropdownMenuEl.value, {
      placement: 'bottom-end',
      modifiers: [minWidth, topSpaceOffset],
    });
  }
  window.addEventListener('click', onWindowClick);
});

function onItemClick(item: DropdownMenuItem) {
  item.action();
  toggleShow(false);
}

onBeforeUnmount(() => {
  popper?.destroy();
  window.removeEventListener('click', onWindowClick);
});

function toggleShow(show?: boolean) {
  isMenuShown.value = show ?? !isMenuShown.value;

  popper?.update();
}

return { __sfc: true,isMenuShown, dropdownMenuEl, dropdownTarget, popper, onWindowClick, minWidth, topSpaceOffset, onItemClick, toggleShow, VButton, MaterialIcon }
}

})